import connectionsStore, { DraggedElementInfo3, PlaceID3 } from "@mobx/store/connections";
import { Point } from "framer-motion";
import { MutableRefObject, useEffect, useMemo, useRef, useState } from "react";

export type DragEvent3 = (info: DraggedElementInfo3[], point?: Point) => void;

export const useSchemeDragTarget3 = (self: MutableRefObject<HTMLElement | null>, placeID?: PlaceID3, onOver?: DragEvent3, onDrop?: DragEvent3) => {
  const dragStore = useMemo(() => placeID ? (connectionsStore.getPlaceStore(placeID)?.drag) : undefined, [placeID]);
  const [over, setOver] = useState(false);
  const [waits, setWaits] = useState(false);
  const [pos, setPos] = useState<Point>();
  const refOver = useRef(over);

  useEffect(() => {
    if (!dragStore) return;
    //console.log(">>> TARGET", mousePos, shift);
    if (dragStore.mousePos && dragStore.shift) setPos({ x: dragStore.mousePos.x + dragStore.shift.x, y: dragStore.mousePos.y + dragStore.shift.y });
    else setPos(undefined);
  }, [dragStore?.mousePos, dragStore?.shift]);

  useEffect(() => {
    if (!dragStore) return;
    if (!dragStore.isDrag) {
      if (over && onDrop) {
        onDrop(dragStore.draggedElements, pos);
      }
      setOver(false);
      setWaits(false);
    }
  }, [dragStore?.isDrag]);

  useEffect(() => {
    if (!dragStore?.isDrag || !self.current || !pos) return;
    const rect = self.current.getBoundingClientRect();
    setOver(pos.x > rect.left && pos.x < rect.right && pos.y > rect.top && pos.y < rect.bottom);
  }, [pos]);

  useEffect(() => {
    refOver.current = over;
    if (over) {
      setTimeout(() => {
        if (refOver.current) {
          setWaits(true);
        }
      }, 400);
    } else {
      setWaits(false);
    }
  }, [over]);

  useEffect(() => {
    if (onOver) {
      if (waits) onOver(dragStore?.draggedElements ?? [], pos);
      else onOver([], pos);
    }
  }, [waits]);
}
